import React from 'react'
import useSWR from 'swr'
import fetcher from '@lib/fetcher'
import EventsList from '../day-picker/event-list'

const OtherEventsList = ({ date, excludeEvent }) => {
  console.log('OtherEventsList props:', { date, excludeEvent })
  
  // Fetch events for the specified date
  const {
    data: instances,
    error,
    isLoading
  } = useSWR(date ? `/whatson/${date}` : null, fetcher)

  console.log('API response:', { instances, error, isLoading })

  // Filter out the current event
  const filteredInstances = instances?.filter(instance => {
    const shouldInclude = instance.event.id !== parseInt(excludeEvent)
    console.log(`Event ${instance.event.name} (ID: ${instance.event.id}), exclude: ${excludeEvent}, include: ${shouldInclude}`)
    return shouldInclude
  }) || []

  console.log('Filtered instances:', filteredInstances)

  // Convert date string to Date object for EventsList
  const selectedDate = date ? new Date(date + 'T00:00:00') : new Date()

  // If no other events, show a message instead of hiding
  if (!isLoading && (!filteredInstances || filteredInstances.length === 0)) {
    return (
      <div className="p-3 sm:p-4 text-gray-600 dark:text-gray-400">
        No other events on this day.
      </div>
    )
  }

  return (
    <div className="pb-3 sm:pb-4">
      <EventsList
        instances={filteredInstances}
        isLoading={isLoading}
        isError={!!error}
        selectedDate={selectedDate}
        availability={null}
        onDateSelect={null}
      />
    </div>
  )
}

export default OtherEventsList